import type { JSX } from "preact";
import { useState } from "preact/hooks";
import { Button } from "@gss/components/Button";
import { Col } from "@gss/components/Col";
import { InputCheckboxLabel } from "@gss/components/InputCheckboxLabel";
import { useMessages } from "@gss/components/Messages";
import { Row } from "@gss/components/Row";
import { Select } from "@gss/components/Select";
import type { MeasurementStat } from "@gss/types/measurementStat";
import { DAO } from "../DAO";
import type { Option } from "../export/export.types";
import { useTranslation } from "../util/Translation";
import { ExportRawDisclaimer } from "./ExportRawDisclaimer";

interface Props {
    stat: MeasurementStat;
    regions: Option[];
}

export function DownloadRaw({ stat, regions }: Props): JSX.Element {
    const [region, setRegion] = useState(regions[0].value);
    const [includeFreeText, setIncludeFreeText] = useState(false);
    const t = useTranslation().translation.download;
    const { addError } = useMessages();

    const download = () => {
        DAO.export
            .downloadRawRegion(
                stat.measurement,
                stat.periods,
                region,
                includeFreeText,
            )
            .catch(addError);
    };

    const renderRegionSelection = () => {
        if (regions.length === 1) {
            return null;
        }
        return (
            <Select value={region} onChange={setRegion}>
                {regions.map((region) => ({
                    value: region.value,
                    children: region.name,
                }))}
            </Select>
        );
    };

    const title = t.downloadRegionalRawData;

    return (
        <section aria-label={title}>
            <h2>{title}</h2>

            <ExportRawDisclaimer name="regional rådata" />

            <Row>
                <Col xs="4">
                    <Button variant="primary" onClick={download}>
                        {title}
                    </Button>
                </Col>

                <Col xs="3">
                    <InputCheckboxLabel
                        checked={includeFreeText}
                        onChange={setIncludeFreeText}
                    >
                        {t.includeFreeText}
                    </InputCheckboxLabel>
                </Col>

                <Col>{renderRegionSelection()}</Col>
            </Row>
        </section>
    );
}
